import CurrencyInput from "react-currency-input-field";

// Numeric/currency input styled to the Form Field spec.
export default function CurrencyField({ error = false, className = "", ...rest }) {
  const classes = [
    "peb-input",
    "peb-input--number",
    error ? "peb-input--error" : "",
    className,
  ].filter(Boolean).join(" ");
  return (
    <CurrencyInput
      className={classes}
      decimalsLimit={2}
      decimalSeparator=","
      groupSeparator="."
      {...rest}
    />
  );
}
